module.exports = __webpack_public_path__ + "img/firefox.1618162e.svg";